"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('composition', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8278 21.7859L21.9683 39.6454C18.554 43.0597 12.937 42.9783 9.42225 39.4636C5.90753 35.9489 5.82612 30.3318 9.24042 26.9175L27.0999 9.05798",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M39.8278 21.7859L21.9683 39.6454C18.554 43.0597 12.937 42.9783 9.42225 39.4636C5.90753 35.9489 5.82612 30.3318 9.24042 26.9175L27.0999 9.05798",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M8.73401 27.4238L34.8781 26.7356",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M26.3928 23.9069C27.1738 23.1258 27.1738 21.8595 26.3928 21.0785C25.6117 20.2974 24.3454 20.2974 23.5644 21.0785C22.7833 21.8595 22.7833 23.1258 23.5644 23.9069C24.3454 24.6879 25.6117 24.6879 26.3928 23.9069Z",
    fill: props.innerStrokeColor
  }), _react.default.createElement("path", {
    d: "M20.7359 26.7355C21.517 25.9545 21.517 24.6881 20.7359 23.9071C19.9549 23.126 18.6885 23.126 17.9075 23.9071C17.1265 24.6881 17.1265 25.9545 17.9075 26.7355C18.6885 27.5166 19.9549 27.5166 20.7359 26.7355Z",
    fill: props.innerStrokeColor
  }), _react.default.createElement("path", {
    d: "M23.5644 5.52246L43.3634 25.3215",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  })));
});

exports.default = _default;